import React, { useState } from "react";
import { Settings, Info } from "lucide-react";
import { Toggle, showAlert, showErrorAlert } from "../../../../../../../components/ui/index.js";

const notificationOptions = [
    {
        name: "allowNotifications",
        title: "Permitir notificaciones",
        desc: "Recibe notificaciones sobre actividad en tu cuenta",
    },
    {
        name: "allowEmailMarketing",
        title: "Emails promocionales",
        desc: "Recibe información sobre nuevas funciones y ofertas",
    },
];

function PrivacyRow({ title, desc, checked, onChange }) {
    return (
        <div className="flex items-center justify-between gap-4">
            <div className="min-w-0">
                <p className="font-medium text-base-content">{title}</p>
                <p className="text-sm text-base-content/70">{desc}</p>
            </div>
            <Toggle checked={checked} onChange={onChange} color="primary" />
        </div>
    );
}

const PrivacidadUserProfile = () => {
    const [privacySettings, setPrivacySettings] = useState({
        allowNotifications: true,
        allowEmailMarketing: false,
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleToggle = (name) => (value) => {
        setPrivacySettings((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            // TODO: persistir en el backend cuando exista el endpoint de privacidad
            console.log("Privacy settings:", privacySettings);
            showAlert({
                title: "Configuración guardada",
                text: "Tus preferencias de privacidad se han actualizado.",
                icon: "success",
            });
        } catch (error) {
            console.error("Error saving privacy settings:", error);
            showErrorAlert({ text: "No se pudo guardar la configuración. Inténtalo de nuevo." });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="glassCard rounded-2xl p-6 w-full">
            {/* Header */}
            <div className="flex items-center gap-3 mb-6 pb-4 border-b border-base-300">
                <div className="p-2 bg-primary/20 rounded-lg">
                    <Settings className="h-6 w-6 text-primary" />
                </div>
                <div>
                    <h2 className="text-xl font-bold text-base-content">Configuración de privacidad</h2>
                    <p className="text-base-content/70 text-sm">Controla cómo compartes tu información y contenido</p>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                {/* Notificaciones */}
                <div className="flex flex-col gap-4">
                    <h3 className="text-lg font-semibold text-base-content">Notificaciones</h3>
                    {notificationOptions.map((opt) => (
                        <PrivacyRow
                            key={opt.name}
                            title={opt.title}
                            desc={opt.desc}
                            checked={privacySettings[opt.name]}
                            onChange={handleToggle(opt.name)}
                        />
                    ))}
                </div>

                {/* Información adicional */}
                <div role="alert" className="alert alert-info">
                    <Info size={18} className="shrink-0" />
                    <div>
                        <h3 className="font-bold">Información importante</h3>
                        <div className="text-sm">
                            Estas configuraciones afectan cómo otros usuarios pueden interactuar contigo y ver tu
                            contenido. Puedes cambiarlas en cualquier momento.
                        </div>
                    </div>
                </div>

                {/* Acciones */}
                <div className="pt-4 border-t border-base-300 flex items-center justify-between gap-4">
                    <span className="text-sm text-base-content/70">Los cambios se aplicarán inmediatamente</span>
                    <button
                        type="submit"
                        disabled={isLoading}
                        className={`btn btn-primary btn-sm ${isLoading ? "loading" : ""}`}
                    >
                        {isLoading ? "Guardando..." : "Guardar configuración"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default PrivacidadUserProfile;
